import React from 'react';
import styled from 'styled-components';
import { colors, remCalc, layout } from '@prisjakt/ui-base';
import HideableBox, { SPEEDS, DELAYS } from '@prisjakt/ui-hideable-box';
import Button from '@prisjakt/ui-button';
import AccountIconBase from 'mdi-react/AccountIcon';
import AlertsIconBase from 'mdi-react/BellOutlineIcon';
import ListsIconBase from 'mdi-react/HeartOutlineIcon';
import { MenuItem } from '../../views/user/styles';

const baseMargin = 8;

export const UserMenu = styled(HideableBox).attrs({
  speed: SPEEDS.SLOW,
  delayIn: DELAYS.SHORTER,
})`
  margin-bottom: ${layout.spacing.xSmall};
`;

export const UserMenuList = styled.div`
  border-bottom: 1px solid ${props => props.theme.lines.primary};
  display: flex;
  flex: 1 0 calc(100% - ${remCalc(baseMargin * 2)});
  flex-direction: column;
  padding-bottom: ${remCalc(baseMargin * 2)};
  margin-top: ${layout.spacing.small};
`;

export const UserMenuItem = styled(MenuItem).attrs({ sidebar: true })``;

export const IconWrapper = styled.div`
  border-radius: 50%;
  color: ${colors.lightBlue3};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: ${colors.semiWhite};
`;

export const LoginButtonWrapper = styled.div`
  margin-left: ${layout.spacing.xSmall};
  margin-right: ${layout.spacing.xSmall};
`;

export const LoginButton = styled(Button)`
  margin-bottom: ${layout.spacing.xSmall};
  width: 100%;
`;

export const AccountIcon = () => (
  <IconWrapper>
    <AccountIconBase />
  </IconWrapper>
);

export const AlertsIcon = () => (
  <IconWrapper>
    <AlertsIconBase size={28} />
  </IconWrapper>
);

export const ListsIcon = () => (
  <IconWrapper>
    <ListsIconBase size={28} />
  </IconWrapper>
);
